module.exports = __webpack_public_path__ + "static/media/sleeping-giants.dbd37e35.jpeg";